import React, { useState } from "react";
import DrawerWrapper from "../../../layout/DrawerWrapper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { Link } from "react-router-dom";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import CreateIcon from "@material-ui/icons/Create";

export const Sidebar = () => {
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);

  const styleLink = {
    color: "white",
    fontSize: "16px",
    textDecoration: "none",
  };
  const styleListItem = {
    backgroundColor: "#a67835",
    paddingTop: 0,
    marginTop: "-10px",
  };
  const styleListItemIcon = {
    color: "white",
    minWidth: "46px",
    marginLeft: "9px",
  };
  const styleDoubleArrow = { fontSize: "18px", marginLeft: "-9px" };

  const mainList = (
    <React.Fragment>
      {/* 1 level */}
      <Link style={styleLink} to={"/dashboard/cases/yourcases"}>
        <ListItem button>
          <ListItemIcon style={{ color: "white" }}>
            <MenuBookIcon></MenuBookIcon>
            <ListItemText
              primary={"Your Cases"}
              style={{ marginLeft: "31px" }}
            />
          </ListItemIcon>
        </ListItem>
      </Link>
      <Link style={styleLink} to={"/dashboard/cases/create"}>
        <ListItem button>
          <ListItemIcon style={{ color: "white" }}>
            <CreateIcon></CreateIcon>
            <ListItemText primary={"Create"} style={{ marginLeft: "31px" }} />
          </ListItemIcon>
        </ListItem>
      </Link>
    </React.Fragment>
  );

  const secondaryList = <React.Fragment></React.Fragment>;

  return (
    <DrawerWrapper
      mainList={mainList}
      secondaryList={secondaryList}
    ></DrawerWrapper>
  );
};

export default Sidebar;
